module.exports = __webpack_public_path__ + "images/emoji/dango.55e5835a38219a4a447d.png";